import { handleValidationChange } from "../CommonValidation";

export const validateBuildItem = (data, items, setIsError) => {
    //Required
    /*
        branch_from: false,
        qty: false,
        ingredients: false
    */
    var isValid = true;

    if (data.branch_from === "" || data.branch_from === null || data.branch_from === undefined) {
        handleValidationChange("branch_from", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("branch_from", false, setIsError);
    }

    if (data.branch_to === "" || data.branch_to === null || data.branch_to === undefined) {
        handleValidationChange("branch_to", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("branch_to", false, setIsError);
    }

    if (data.requested_by === "" || data.requested_by === null || data.requested_by === undefined) {
        handleValidationChange("requested_by", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("requested_by", false, setIsError);
    }

    if (data.type === "" || data.type === null || data.type === undefined) {
        handleValidationChange("type", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("type", false, setIsError);
    }

    if (data.build_item_id === "" || data.build_item_id === null || data.build_item_id === undefined) {
        handleValidationChange("build_item_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("build_item_id", false, setIsError);
    }

    if (data.build_item_qty === "" || data.build_item_qty === null || data.build_item_qty === undefined) {
        handleValidationChange("build_item_qty", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("build_item_qty", false, setIsError);
    }

    if (items.length < 1) {
        handleValidationChange("items", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("items", false, setIsError);
    }

    return isValid;
};


// to check if sales items required filleds have data
export const validateBuildItemTable = (items) => {
        const errors = {};
        // const finalItems = []
        items.map((item, itemIndex) => {
        if (item.item_id === '' || item.item_id === null || item.item_id === undefined) {
            errors[itemIndex] = {
            ...errors[itemIndex],
            item_id: 'Item is required',
            };
        }

        if (!(item.qty?.toString())||item.qty==='') {
            errors[itemIndex] = {
            ...errors[itemIndex],
            qty: 'Qty is required',
            };
        }

        if (!(item.qty_used?.toString())||item.qty_used==='') {
            errors[itemIndex] = {
            ...errors[itemIndex],
            qty_used: 'Qty Used is required',
            };
        }

        });

        return errors;

}